@if (isLabeled()) {
  <div class="tc-switch">
    @if (leftLabel()) {
      <span
        class="tc-switch__label"
        [class.tc-switch__label--active]="isChecked()"
      >
        {{ leftLabel() }}
      </span>
    }

    <button
      type="button"
      class="tc-switch__track"
      [class.tc-switch__track--on]="isChecked()"
      role="switch"
      [attr.aria-checked]="isChecked()"
      [attr.aria-label]="switchAriaLabel()"
      [disabled]="isDisabled()"
      (click)="toggle()"
    >
      <span class="tc-switch__thumb"></span>
    </button>

    @if (rightLabel()) {
      <span
        class="tc-switch__label"
        [class.tc-switch__label--active]="!isChecked()"
      >
        {{ rightLabel() }}
      </span>
    }
  </div>
} @else {
  <button
    type="button"
    ngpSwitch
    class="tc-switch__track tc-switch__track--compact"
    [class.tc-switch__track--on]="isChecked()"
    role="switch"
    [attr.aria-checked]="isChecked()"
    [attr.aria-label]="switchAriaLabel()"
    [ngpSwitchChecked]="isChecked()"
    [ngpSwitchDisabled]="isDisabled()"
    (ngpSwitchCheckedChange)="onCheckedChange($event)"
  >
    <span class="tc-switch__thumb tc-switch__thumb--compact" ngpSwitchThumb></span>
  </button>
}
